import React, { useContext, useEffect, useState } from 'react';
import { SEO, PrimaryLayout } from '../../components';
import { RateQuote } from '@/../types/index';
import { Context } from '@/context';
import { getPhoneNumber } from '@/utils';

function AccessibilityPage() {
  const ctx = useContext<RateQuote.AppState>(Context);
  const category = ctx?.user?.category;
  const [dynamicNumber, setDynamicNumber] = useState('');

  useEffect(() => {
    if (category) {
      setDynamicNumber(getPhoneNumber(category));
    }
  }, [category]);

  return (
    <>
      <SEO
        title="Accessibility - RateQuote"
        description="RateQuote and RateQuote Direct Accessibility"
      />
      <PrimaryLayout>
        <div className="max-w-3-1/2xl mx-auto flex w-full flex-col px-5 pb-28 sm:px-0 md:flex-row md:space-x-6">
          <div className="mx-auto w-full md:w-[85%]">
            <h1 className="text-light mb-4 text-center text-5xl md:text-left">
              RateQuote and RateQuote Direct Accessibility
            </h1>
            <p className="c-sanity-p mb-6 text-center md:text-left">
              RateQuote and RateQuote Direct are committed to making our
              website&apos;s content accessible and user friendly to everyone.
              If you are having difficulty viewing or navigating the content on
              this website, or notice any content, feature, or functionality
              that you believe is not fully accessible to people with
              disabilities, please call our Customer Service team at{' '}
              <a
                href={`tel:${dynamicNumber}`}
                className="hover:underline"
                title="Call us"
              >
                {dynamicNumber}
              </a>{' '}
              or email our team at{' '}
              <a
                href="mailto:info@ratequote.com"
                className="text-blue-primary hover:underline"
                title="Send an email"
              >
                info@ratequote.com
              </a>{' '}
              describing the service you are looking for help with and or with
              details around what feature can be made more accessible. Also, we
              hold our vendors to the highest standards and we strongly
              encourage vendors of third-party digital content to provide
              content that is accessible and user friendly.
            </p>
          </div>
        </div>
      </PrimaryLayout>
    </>
  );
}

export default AccessibilityPage;
